import { getAllTeams } from '../lib/apilib'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Loader from '../components/loader'
import { FaSortUp, FaSortDown } from 'react-icons/fa'
import useTeamCodes from '../lib/teamCodes'
import RatingNum from '../components/RatingNum'
import useRegionColors from '../lib/regionColors'
import { useMobileDetect } from '../lib/hooks'

export default function EloTeams() {
  const [teams, setTeams] = useState([])
  const [activeRegions, setActiveRegions] = useState([])
  const [allRegions, setAllRegions] = useState([])
  const [filterText, setFilterText] = useState('')
  const [reverse, setReverse] = useState(false)
  const [sort, setSort] = useState('top') // ['ratio', 'members', 'women', 'rating', 'team', 'womenteam']

  const [loaded, setLoaded] = useState(false)

  const [searchParams] = useSearchParams()
  const linkRegion = searchParams.get('region')
  const linkSort = searchParams.get('sort')

  const RegionColors = useRegionColors()

  const isMobile = useMobileDetect()

  useEffect(() => {
    setLoaded(false)
    getAllTeams()
      .then((tempTeams) => {
        setTeams(tempTeams)
        let regions = tempTeams.map((team) => team.region).filter((value, index, self) => self.indexOf(value) === index)
        if (linkRegion === null) {
          setActiveRegions(regions)
        } else {
          setActiveRegions([linkRegion])
        }

        if (linkSort !== null) {
          setSort(linkSort)
        }

        setAllRegions(regions)
      })
      .then(() => setLoaded(true))
  }, [])

  const toggleFilter = (region) => {
    if (activeRegions.indexOf(region) !== -1) {
      setActiveRegions(activeRegions.filter((reg) => reg !== region))
    } else {
      setActiveRegions((activeRegions) => [...activeRegions, region])
    }
  }
  const filter = (e) => {
    setFilterText(e.target.value)
  }

  const filtered = teams
    .filter((team) => {
      if (filterText !== '') {
        return team.teamName.toLowerCase().includes(filterText.toLowerCase())
      }
      return true
    })
    .filter((team) => {
      let temp = true
      // if (byRatio || byMembers) {
      //   temp = team.memberCount > 0
      // }
      return activeRegions.indexOf(team.region) !== -1 && temp
    })
    .sort((a, b) => {
      if (reverse) [a, b] = [b, a]
      if (sort === 'ratio') return b.avgRatio - a.avgRatio
      else if (sort === 'members') return b.memberCount - a.memberCount
      else if (sort === 'rating') return b.avgRating - a.avgRating
      else if (sort === 'women') return b.topWomenRating - a.topWomenRating
      else if (sort === 'team') return b.topTeamRating - a.topTeamRating
      else if (sort === 'womenteam') return b.topWomenTeamRating - a.topWomenTeamRating
      // sort === 'top'
      else return b.topFleetRating - a.topFleetRating
    })

  return (
    // style={{ position: 'fixed', overflowY: 'hidden', zIndex: 100 }}
    <div>
      {loaded ? (
        <>
          <div className='flexRowContainer filterHeader'>
            <input className='flexGrowChild' placeholder='Search for a team' onChange={filter} />
            <div className='flexRowContainer'>
              {Object.keys(RegionColors).map((region, i) => (
                <button key={i} style={{ backgroundColor: activeRegions.indexOf(region) !== -1 ? RegionColors[region] : '' }} className={`filterOption ${activeRegions.indexOf(region) !== -1 ? '' : 'filterInactive'}`} onClick={() => toggleFilter(region)} onDoubleClick={() => setActiveRegions([region])}>
                  {region}
                </button>
              ))}
              <button className='filterOption filterInactive' onClick={() => setActiveRegions(allRegions)}>
                Show all
              </button>
              <button className='filterOption filterInactive' onClick={() => setActiveRegions([])}>
                Hide all
              </button>
            </div>
          </div>
          {isMobile ? <MobileTeams reverse={reverse} setReverse={setReverse} sort={sort} setSort={setSort} filtered={filtered} /> : <DesktopTeams reverse={reverse} setReverse={setReverse} sort={sort} setSort={setSort} filtered={filtered} />}
        </>
      ) : (
        <Loader show={!loaded} />
      )}
    </div>
  )
}

const MobileTeams = ({ reverse, setReverse, filtered, sort, setSort }) => {
  const teamCodes = useTeamCodes()
  const RegionColors = useRegionColors()
  const navigate = useNavigate()

  const temp = useRef(null)

  return (
    <>
      <div className='teamTableContainer' style={{ maxWidth: '100%' }} ref={temp}>
        {filtered.map((team, index) => (
          <MobileTeam key={index} team={team} index={index} teamCodes={teamCodes} RegionColors={RegionColors} navigate={navigate} sort={sort} />
        ))}
      </div>
      <MobileControls sort={sort} setSort={setSort} reverse={reverse} setReverse={setReverse} temp={temp} />
    </>
  )
}

const MobileTeam = ({ team, index, teamCodes, RegionColors, navigate, sort }) => {
  const ratings = { top: team.topFleetRating, women: team.topWomenRating, team: team.topTeamRating, womenteam: team.topWomenTeamRating, rating: team.avgRating, members: team.memberCount }
  const iconSrcs = { top: 'OpenFleetIcon.png', women: 'WomensFleetIcon.png', team: 'OpenTeamIcon.png', womenteam: 'WomensTeamIcon.png' }

  return (
    <div key={index} className='mobileTeamRow' onClick={() => navigate(`/teams/${team.teamID}`)}>
      <div style={{ padding: '0.5rem', width: '2rem' }}>{index + 1}</div>
      <img style={{ display: 'inline', maxHeight: '2rem', minWidth: '3rem' }} src={`https://scores.collegesailing.org/inc/img/schools/${teamCodes[team.teamID]}.png`} alt='' />
      <div className='flexCol' style={{ width: '100%' }}>
        <div className='flexRowContainer' style={{ alignItems: 'center', width: '100%' }}>
          <div className='filterOption' style={{ backgroundColor: RegionColors[team.region] }}>
            {team.region}
          </div>
          <strong>{team.teamName}</strong>
          <div className='flexGrowChild'></div>
          <div className='flexRowCentered'>
            <img src={iconSrcs[sort]} style={{ height: '1.5rem' }} alt='' />
            {ratings[sort]}
          </div>
        </div>
      </div>
    </div>
  )
}

const MobileControls = ({ sort, setSort, reverse, setReverse, temp }) => {
  const scrollToTop = () => {
    if (temp.current) {
      temp.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }

  return (
    <div className='mobileControlsContainer'>
      <div className='mobileControlsGrid'>
        <div style={{ gridArea: '1 / 1 / 1 / 3' }}>
          <label className='fleetTeamSwitch' for='checkbox'>
            <input
              id='checkbox'
              type='checkbox'
              checked={sort === 'team' || sort === 'womenteam'}
              onChange={(input) => {
                let team = input.target.checked
                setReverse(false)

                if (team) {
                  if (sort === 'women' || sort === 'womenteam') {
                    setSort('womenteam')
                  } else {
                    setSort('team')
                  }
                } else {
                  if (sort === 'womenteam') {
                    setSort('women')
                  } else {
                    setSort('top')
                  }
                }
              }}
            />
            <div className='fleetTeamSlider'></div>
            <div className='fleetTeamSliderLabel'>
              <span>Fleet</span>
              <span>Team</span>
            </div>
          </label>
        </div>
        <div style={{ gridArea: '2 / 1 / 2 / 3' }}>
          <label className='fleetTeamSwitch' for='womensCheckbox'>
            <input
              id='womensCheckbox'
              type='checkbox'
              checked={sort === 'women' || sort === 'womenteam'}
              onChange={(input) => {
                let womens = input.target.checked
                setReverse(false)

                if (womens) {
                  if (sort === 'team' || sort === 'womenteam') {
                    setSort('womenteam')
                  } else {
                    setSort('women')
                  }
                } else {
                  if (sort === 'team' || sort === 'womenteam') {
                    setSort('team')
                  } else {
                    setSort('top')
                  }
                }
              }}
            />
            <div className='fleetTeamSlider'></div>
            <div className='fleetTeamSliderLabel'>
              <span>Open</span>
              <span>Women</span>
            </div>
          </label>
        </div>

        <button
          onClick={() => {
            setReverse(false)
            setSort(sort === 'rating' ? 'top' : 'rating')
          }}
          style={{ backgroundColor: sort === 'rating' ? 'var(--border)' : 'var(--bg)' }}>
          Avg
        </button>
        <button
          onClick={() => {
            if (sort === 'members') {
              if (!reverse) {
                setReverse(true)
              } else {
                setSort('top')
                setReverse(false)
              }
            } else {
              setSort('members')
              setReverse(false)
            }
          }}
          style={{ backgroundColor: sort === 'members' ? 'var(--border)' : 'var(--bg)' }}>
          Members
        </button>

        <button onClick={() => scrollToTop()} style={{ backgroundColor: 'var(--bg)', gridArea: '2 / 3 / 2 / 5' }}>
          Back to top
        </button>
      </div>
    </div>
  )
}

const DesktopTeams = ({ reverse, setReverse, filtered, sort, setSort }) => {
  const navigate = useNavigate()
  const temp = useRef(null)

  const teamCodes = useTeamCodes()
  const RegionColors = useRegionColors()

  const scrollToTop = () => {
    if (temp.current) {
      temp.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }

  return (
    <>
      <div className='teamTableContainer'>
        <table className='raceByRaceTable teamsTable' ref={temp}>
          <thead>
            <tr style={{ fontSize: '1.1rem' }}>
              <th style={{ minWidth: 40, textAlign: 'right', height: '2.5rem' }}></th>
              <th style={{ minWidth: 50 }}> </th>
              <th>Team</th>
              <th>Conference</th>
              <th
                className='tableColFit tooltip'
                onClick={() => {
                  setReverse(false)
                  setSort('top')
                }}
                style={{ minWidth: 80, textAlign: 'right' }}>
                {sort === 'top' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}
                Open
                <span className='tooltiptext'>Takes avg the top 3 from each pos</span>
              </th>
              <th
                className='tableColFit tooltip'
                onClick={() => {
                  setReverse(false)
                  setSort(sort === 'women' ? 'top' : 'women')
                }}
                style={{ minWidth: 105, textAlign: 'right' }}>
                {sort === 'women' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}
                Women's
                <span className='tooltiptext'>Takes avg the top 2 from each pos</span>
              </th>
              <th
                className='tableColFit tooltip'
                onClick={() => {
                  setReverse(false)
                  setSort(sort === 'team' ? 'top' : 'team')
                }}
                style={{ minWidth: 100, textAlign: 'right' }}>
                {sort === 'team' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}
                Open TR
                <span className='tooltiptext'>Takes avg the top 3 from each pos</span>
              </th>
              <th
                className='tableColFit tooltip'
                onClick={() => {
                  setReverse(false)
                  setSort(sort === 'womenteam' ? 'top' : 'womenteam')
                }}
                style={{ minWidth: 130, textAlign: 'right' }}>
                {sort === 'womenteam' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}
                Women's TR
                <span className='tooltiptext'>Takes avg the top 3 from each pos</span>
              </th>
              <th
                className='tableColFit tooltip'
                onClick={() => {
                  setReverse(false)
                  setSort(sort === 'rating' ? 'top' : 'rating')
                }}
                style={{ minWidth: 125, textAlign: 'right' }}>
                <span className='tooltiptext'>Avg Rating of all sailors</span>
                {sort === 'rating' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}Avg Rating
              </th>
              <th
                style={{ minWidth: 130, textAlign: 'right' }}
                className='tableColFit'
                onClick={() => {
                  setReverse(false)
                  setSort(sort === 'ratio' ? 'top' : 'ratio')
                }}>
                {sort === 'ratio' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}Percentage
              </th>
              <th
                style={{ minWidth: 88, textAlign: 'right' }}
                className='tableColFit'
                onClick={() => {
                  if (sort === 'members') {
                    if (!reverse) {
                      setReverse(true)
                    } else {
                      setSort('top')
                      setReverse(false)
                    }
                  } else {
                    setSort('members')
                    setReverse(false)
                  }
                }}>
                {sort === 'members' ? reverse ? <FaSortUp /> : <FaSortDown /> : <></>}
                Sailors
              </th>

              <th></th>
            </tr>
          </thead>
          <tbody className='teamsTable'>
            {filtered.length > 0 ? (
              filtered.map((team, index) => (
                <tr key={index} className='clickable' onClick={() => navigate(`/teams/${team.teamID}`)}>
                  <td className='tableColFit tdRightBorder' style={{ textAlign: 'right' }}>
                    {(sort === 'rating' ? team.avgRating !== 0 : sort === 'women' ? team.topWomenRating !== 0 : sort === 'members' ? team.memberCount !== 0 : sort === 'ratio' ? team.avgRatio !== 0 : sort === 'team' ? team.topTeamRating !== 0 : team.topFleetRating !== 0) ? (
                      index + 1
                    ) : (
                      <span className='secondaryText' style={{ textAlign: 'right' }}>
                        ~
                      </span>
                    )}
                  </td>
                  <td className='tableColFit'>
                    <img style={{ display: 'inline', maxHeight: '2rem' }} src={`https://scores.collegesailing.org/inc/img/schools/${teamCodes[team.teamID]}.png`} alt='' />
                  </td>

                  <td className='tableColFit'>{team.teamName}</td>
                  <td className=''>
                    <div className='filterOption' style={{ backgroundColor: RegionColors[team.region] }}>
                      {team.region}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <RatingNum ratingNum={team.topFleetRating} />
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <RatingNum ratingNum={team.topWomenRating} type={'women'} />
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <RatingNum ratingNum={team.topTeamRating} type={'open'} raceType={'team'} />
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <RatingNum ratingNum={team.topWomenTeamRating} type={'women'} raceType={'team'} />
                    </div>
                  </td>
                  <td style={{ textAlign: 'right' }}>{team.avgRating.toFixed(0)}</td>

                  <td style={{ textAlign: 'right' }}>
                    <div className='ratioBarBg'>
                      <div className='ratioBar' style={{ width: team.avgRatio * 100 }}>
                        <span>{(team.avgRatio * 100).toFixed(1)}%</span>
                      </div>
                    </div>
                  </td>
                  <td className='' style={{ textAlign: 'right' }}>
                    {team.memberCount}
                  </td>
                  <td></td>
                </tr>
              ))
            ) : (
              <tr>
                <span style={{ width: '100%', position: 'absolute', textAlign: 'center', margin: 20 }}>Please select at least one conference!</span>
              </tr>
            )}
          </tbody>
        </table>
        {/* <ScrollButton element={temp} /> */}
      </div>
      <button
        className='scrollButton'
        onClick={() => {
          scrollToTop()
        }}>
        Back to top
      </button>
    </>
  )
}
